/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

/**
 * Komunikátor pro úlohy ve starém formátu
 */
class TaskCommunicator {
  /**
   * @param {ContentTaskToTaskConverter} contentTaskConverter
   * @param {PowerTaskToTaskConverter} powerTaskConverter
   */
  constructor(contentTaskConverter, powerTaskConverter) {
    this.contentTaskConverter = contentTaskConverter;
    this.powerTaskConverter = powerTaskConverter;
  }

  /**
   * Načte úlohy ve starém formátu.
   * @param {Array.<ContentTask>} contentTasks
   * @param {Array.<PowerTask>} powerTasks
   * @param {Store} store
   * @returns {Array.<Task>}
   */
  parse(contentTasks, powerTasks, store) {
    const contentTypeTasks = this.parseContentTasks(contentTasks, store);
    const powerTypeTasks = this.parsePowerTasks(powerTasks, store);
    return [...contentTypeTasks, ...powerTypeTasks];
  }

  /**
   * Načte úlohy ve starém formátu z obsahových úloh.
   * @param {Array.<ContentTask>} contentTasks
   * @param {Store} store
   * @returns {Array.<Task>}
   */
  parseContentTasks(contentTasks, store) {
    return contentTasks.reduce((acc, contentTask) => {
      // Migrace úloh z nového do starého formátu.?
      const task = this.contentTaskConverter.convert(contentTask, store);
      // Ne všechny úlohy jdou převést, použijí se pouze ty, které lze.
      if (!isNil(task)) {
        acc.push(task);
      }
      return acc;
    }, []);
  }

  /**
   * Načte úlohy ve starém formátu z napájecích úloh.
   * @param {Array.<PowerTask>} powerTasks
   * @param {Store} store
   * @returns {Array.<Task>}
   */
  parsePowerTasks(powerTasks, store) {
    return powerTasks.reduce((acc, powerTask) => {
      // Migrace úloh z nového do starého formátu.
      const task = this.powerTaskConverter.convert(powerTask, store);
      // Ne všechny úlohy jdou převést, použijí se pouze ty, které lze.
      if (!isNil(task)) {
        acc.push(task);
      }
      return acc;
    }, []);
  }
}

export default TaskCommunicator;
